var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxUncheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 1.5,
    fill: "white",
    stroke: "#AAE3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6558 7.28063C13.8055 7.13813 14.0047 7.05936 14.2113 7.06092C14.418 7.06248 14.6159 7.14427 14.7634 7.28901C14.9109 7.43375 14.9964 7.63013 15.0019 7.83671C15.0073 8.04329 14.9323 8.24392 14.7927 8.39625L10.5533 13.6981C10.4804 13.7766 10.3924 13.8397 10.2946 13.8834C10.1968 13.9271 10.0912 13.9507 9.98409 13.9527C9.87697 13.9547 9.77055 13.935 9.67119 13.8949C9.57183 13.8548 9.48158 13.7951 9.40582 13.7194L6.59445 10.908C6.51616 10.835 6.45336 10.7471 6.40981 10.6493C6.36625 10.5516 6.34283 10.4461 6.34094 10.3391C6.33906 10.2321 6.35874 10.1258 6.39882 10.0266C6.4389 9.92733 6.49855 9.83719 6.57422 9.76152C6.64989 9.68585 6.74003 9.6262 6.83925 9.58612C6.93848 9.54604 7.04476 9.52636 7.15175 9.52825C7.25875 9.53014 7.36427 9.55355 7.46202 9.59711C7.55977 9.64066 7.64774 9.70346 7.7207 9.78175L9.94557 12.0056L13.6356 7.304L13.6558 7.28063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUncheckedIcon);
export default __webpack_public_path__ + "static/media/checkbox-unchecked-icon.21ba8a1096ed2bf44492023d556f3d90.svg";
export { ForwardRef as ReactComponent };